export const honours = [
    {
        id: 'stars',
        title: 'Stars',
        category: 'Nature',
        level: 1,
        year: 1928,
        institution: 'General Conference',
        summary: 'Identify stars, constellations, and planets while understanding the celestial movements and wonders of God\'s creation.',
        requirements: [
            'Answer the following questions: a. What is the earth’s nearest celestial neighbor? b. What is its distance from the earth? c. What governs the tide? d. What causes an eclipse? e. What is a shooting star? f. How fast does light travel?',
            'Make a diagram showing relative positions and movements of the earth, sun, and moon. Show positions and movements for eclipses of the sun and moon.',
            'Make a diagram of our solar system and be able to name the planets in order from the sun.',
            'Identify eight fixed stars in the sky. What is the difference between planets and fixed stars?',
            'What is a constellation? Name and point out six. Name two constellations visible throughout the year.',
            'For the Northern Hemisphere: draw a chart of the Big Dipper, Cassiopeia, and the North Star. For the Southern Hemisphere: draw a chart of the Southern Cross, Orion, and Scorpio.',
            'What is the Milky Way? Observe the Milky Way in the night sky.',
            'What is the morning and evening star? Why does it carry both names?',
            'Explain zenith and nadir.',
            'What is the aurora borealis? What causes it?'
        ]
    },
    {
        id: 'fire-building',
        title: 'Fire Building',
        category: 'Recreation',
        level: 2,
        year: 1956,
        institution: 'General Conference',
        summary: 'Master the skill of building and maintaining various types of fires for cooking and warmth, prioritizing safety.',
        requirements: [
            'Lay five different kinds of fires and know their uses. Two of these fires must be cooking fires.',
            'Safely make wood shavings or fuzz sticks.',
            'Show correct techniques for starting a fire.',
            'Start a fire with one match and keep it going for at least 10 minutes.',
            'Know and practice fire safety rules.',
            'Show how to correctly and safely cut and split fire wood.',
            'Demonstrate ability to start fire on a rainy day or in the snow.'
        ]
    },
    {
        id: 'camp-cookery',
        title: 'Camp Cookery',
        category: 'Household Arts',
        level: 2,
        year: 1956,
        institution: 'General Conference',
        summary: 'Learn to prepare nutritious meals outdoors using different cooking methods like boiling, frying, and baking.',
        requirements: [
            'Demonstrate simmering, boiling, frying, baking bread on a stick, aluminum foil baking, reflector oven baking.',
            'Know one method of keeping food cool while camping other than with ice.',
            'Know ways to keep your food and utensils safe from animals and insects.',
            'Why is it important to keep your cooking and eating utensils clean?',
            'Showing knowledge of proper nutrition and food groups, make up a complete and balanced menu for six camping meals. Include the following: a. A breakfast, lunch, or supper good for a trail hike where light weight is important. b. The remaining five meals may be made up of any type of food: canned, fresh, frozen, or dried. One of the five must be a one-pot meal.',
            'Make up a supply list of items that will be needed to prepare the above six meals.',
            'Know how to properly and safely handle food, dispose of trash and garbage, and wash your gear.'
        ]
    },
    {
        id: 'leadership',
        title: 'Junior Youth Leadership',
        category: 'Vocational',
        level: 3,
        year: 1945,
        institution: 'General Conference',
        summary: 'Develop essential youth leadership qualities and learn principles of effective discipline and adolescent development.',
        requirements: [
            'Be a Master Guide.',
            'Read two books on adolescent development or leadership.',
            'Serve in any one of the following offices for one year: a. AY leader or associate leader; b. Primary, Junior, Earliteen, or Youth Sabbath School leader; c. Staff member in an active Pathfinder Club; d. Staff member at a summer youth camp for a full summer program',
            'Prepare a group to be invested in one of the Pathfinder Classes during the current year and assist in conducting the Investiture service.',
            'Know at least 10 qualities of a good youth leader.',
            'Know the difference between juniors (10-12 year olds) and teens (13-15 year olds) in the following areas: a. Physical; b. Emotional; c. Mental; d. Spiritual',
            'Know principles in the proper administration of discipline to youth. Learn the following areas of discipline: a. Internal discipline; b. External discipline; c. Ten ways to prevent need for external discipline; d. Five types of discipline procedures'
        ]
    },
    {
        id: 'knot-tying',
        title: 'Knot Tying',
        category: 'Recreation',
        level: 2,
        year: 1975,
        institution: 'General Conference',
        summary: 'Learn to tie, identify, and apply over 20 essential knots, hitches, and bends for various practical uses.',
        requirements: [
            'Define the following terms: a. Bight, b. Running end, c. Standing part, d. Underhand loop, e. Overhand loop, f. Turn, g. Bend, h. Hitch, i. Splice, j. Whipping',
            'Know how to care for rope.',
            'Describe the difference between laid rope and braided rope and list three uses of each.',
            'Identify the following types of rope: a. Manila, b. Sisal, c. Nylon, d. Polyprophylene',
            'What are some advantages and disadvantages of synthetic rope?',
            'Do the following to rope: a. Splice, b. Eye Splice, c. Back Splice, d. Finish the end of a rope with a double crown, whipping, or a Matthew Walker’s knot.',
            'Make a six-foot piece of three-strand rope from native materials or twine.',
            'From memory tie at least 20 of the following knots and know their common uses and limitations. Demonstrate how they are used: Anchor bend, Bindertwine Bend, Blackwall Hitch, Bow or Shoestring, Bowline, Bowline on a bight, Butterfly loop knot or Alpine Slip knot, Carrick bend, Clove hitch, Double Bowline, Double Carrick Bend, Figure eight, Fisherman’s knot, Halter hitch, Hunter’s bend, Lariat or Bowstring knot, Lark’s head, Man harness knot, Miller’s Knot, Packer’s knot, Pipe hitch, Prusik knot, Running bowline, Sheepshank, Sheet bend, Slipped half hitch, Slipped sheet bend, Square knot, Stevedore’s knot, Strangle knot, Surgeon’s knot, Tautline hitch, Timber hitch, Two half hitches, Wall knot',
            'Make a knot board showing 25 or more knots.'
        ],
        knots: [
            {
                name: 'Square Knot',
                use: 'Joining two ropes of equal thickness',
                description: 'Used for tying two ropes together. Not secure for joining ropes under load and is more suited for bundling items.',
                howToTie: 'Right over left, then left over right. Remember: "Right over left and under, left over right and under."',
                youtubeLink: 'https://www.youtube.com/watch?v=rX8gWwrGBzw',
                youtubeId: 'rX8gWwrGBzw',
                category: 'Binding'
            },
            {
                name: 'Sheet Bend',
                use: 'Joining two ropes of different thickness',
                description: 'Used to join two ropes of different sizes. It\'s strong and secure, but can slip under heavy load if not tied correctly.',
                howToTie: 'Make a bight in the thicker rope. Pass the thinner rope up through the bight, around behind both parts of the thicker rope, then back under itself.',
                youtubeLink: 'https://www.youtube.com/watch?v=x3reZ3NuGaQ',
                youtubeId: 'x3reZ3NuGaQ',
                category: 'Joining'
            },
            {
                name: 'Double Sheet Bend',
                use: 'More secure version for joining ropes of unequal thickness',
                description: 'A more secure version of the sheet bend, used for joining ropes of unequal thickness.',
                howToTie: 'Tie like a sheet bend, but make an extra turn around the bight before tucking under.',
                youtubeLink: 'https://www.youtube.com/watch?v=mMcvXQnPbx4',
                youtubeId: 'mMcvXQnPbx4',
                category: 'Joining'
            },
            {
                name: 'Fisherman\'s Knot',
                use: 'Joining two lines of equal diameter',
                description: 'Used for joining two lines of equal diameter, particularly monofilament fishing line. It\'s very strong but can be difficult to untie.',
                howToTie: 'Tie an overhand knot in one line around the other, then tie an overhand knot in the second line around the first. Pull tight.',
                youtubeLink: 'https://www.youtube.com/watch?v=z7ORr1hhRJo',
                youtubeId: 'z7ORr1hhRJo',
                category: 'Joining'
            },
            {
                name: 'Double Fisherman\'s Knot',
                use: 'Stronger version for climbing applications',
                description: 'A stronger version of the Fisherman\'s Knot, also known as the Grapevine Knot. Often used in climbing.',
                howToTie: 'Like fisherman\'s knot but with double overhand knots instead of single overhand knots.',
                youtubeLink: 'https://www.youtube.com/watch?v=EKpBK3BoYII',
                youtubeId: 'EKpBK3BoYII',
                category: 'Joining'
            },
            {
                name: 'Carrick Bend',
                use: 'Joining large ropes or cables',
                description: 'A reliable and easily untied knot used for connecting two lines. It does not jam even under heavy load.',
                howToTie: 'Form a loop with one rope. Weave the second rope over, under, over, under through the loop in a specific pattern.',
                youtubeLink: 'https://www.youtube.com/watch?v=37T47TP9_lw',
                youtubeId: '37T47TP9_lw',
                category: 'Joining'
            },
            {
                name: 'Fisherman\'s Bend',
                use: 'Attaching rope to a ring or post (Anchor Bend)',
                description: 'Also known as the Anchor Bend, this knot is used to attach a rope to a ring or post. It\'s very secure.',
                howToTie: 'Pass the rope through the ring twice, then tie a half hitch around the standing line, passing the end through both turns.',
                youtubeLink: 'https://www.youtube.com/watch?v=aEn-eJrwef8',
                youtubeId: 'aEn-eJrwef8',
                category: 'Bends'
            },
            {
                name: 'Figure-Eight Bend',
                use: 'Joining two ropes securely',
                description: 'Used to join two ropes. It\'s a secure knot that\'s easy to inspect.',
                howToTie: 'Tie a figure-eight in one rope, then follow the same path with the second rope in reverse.',
                youtubeLink: 'https://www.youtube.com/watch?v=aEn-eJrwef8',
                youtubeId: 'aEn-eJrwef8',
                category: 'Bends'
            },
            {
                name: 'Water Knot',
                use: 'Joining flat webbing',
                description: 'Used to join two pieces of flat webbing together.',
                howToTie: 'Tie an overhand knot in one piece of webbing, then follow the same path with the second piece in reverse.',
                youtubeLink: 'https://www.youtube.com/watch?v=QUqQCkclmYc',
                youtubeId: 'QUqQCkclmYc',
                category: 'Bends'
            },
            {
                name: 'Clove Hitch',
                use: 'Securing rope to a post or pole',
                description: 'A quick and simple hitch for temporary fastening of a rope to a post or pole. It can be tied in the middle of a rope.',
                howToTie: 'Make two turns around the post, crossing the rope over itself each time, then tuck the end under the last turn.',
                youtubeLink: 'https://www.youtube.com/watch?v=EKRFawQCP0Y',
                youtubeId: 'EKRFawQCP0Y',
                category: 'Hitches'
            },
            {
                name: 'Timber Hitch',
                use: 'Dragging logs or poles',
                description: 'Used to attach a rope to a log or post, particularly for hauling. It tightens as it is pulled.',
                howToTie: 'Pass the rope around the log, then wrap the working end around itself several times before pulling tight.',
                youtubeLink: 'https://www.youtube.com/watch?v=nuaQZFZG6f8',
                youtubeId: 'nuaQZFZG6f8',
                category: 'Hitches'
            },
            {
                name: 'Half Hitch',
                use: 'Basic hitch for additional security',
                description: 'This simple knot is often used in combination with other knots to provide added security.',
                howToTie: 'Pass the rope around an object and through its own loop.',
                youtubeLink: 'https://www.youtube.com/watch?v=eKE61zrw4Yk',
                youtubeId: 'eKE61zrw4Yk',
                category: 'Hitches'
            },
            {
                name: 'Taut-Line Hitch',
                use: 'Adjustable hitch for tent guy lines',
                description: 'An adjustable knot used to secure a rope under tension. It is useful for securing tent guy lines.',
                howToTie: 'Make two turns around the standing line toward the anchor, then one turn away from the anchor, and tuck under.',
                youtubeLink: 'https://www.youtube.com/watch?v=OPzOJXMo_zE',
                youtubeId: 'OPzOJXMo_zE',
                category: 'Hitches'
            },
            {
                name: 'Buntline Hitch',
                use: 'Very secure hitch',
                description: 'A very secure hitch, but it can be difficult to untie after being under load.',
                howToTie: 'Pass the rope around the object twice, then tie a clove hitch around the standing line.',
                youtubeLink: 'https://www.youtube.com/watch?v=MdcBntXMbyY',
                youtubeId: 'MdcBntXMbyY',
                category: 'Hitches'
            },
            {
                name: 'Bowline',
                use: 'Making a fixed loop that will not slip',
                description: 'A fundamental loop knot that does not slip or jam. It\'s often called the "King of Knots."',
                howToTie: 'Make a small loop, pass the end up through it, around the standing line, and back down through the loop. "Up through the rabbit hole, round the big tree; down through the rabbit hole and off goes he!"',
                youtubeLink: 'https://www.youtube.com/watch?v=3i6qXrMe9cQ',
                youtubeId: '3i6qXrMe9cQ',
                category: 'Loops'
            },
            {
                name: 'Figure-Eight Loop',
                use: 'Strong and reliable loop for climbing',
                description: 'A strong and reliable loop knot that\'s easy to tie and untie. It is a common climbing knot.',
                howToTie: 'Double the rope, tie a figure-eight knot with the doubled rope.',
                youtubeLink: 'https://www.youtube.com/watch?v=RHsfAbx0cMI',
                youtubeId: 'RHsfAbx0cMI',
                category: 'Loops'
            },
            {
                name: 'Overhand Loop',
                use: 'Simple stopper loop',
                description: 'The simplest of all loops, it is often used as a stopper knot.',
                howToTie: 'Double the rope and tie an overhand knot.',
                youtubeLink: 'https://www.youtube.com/watch?v=CRutv6cQSLY',
                youtubeId: 'CRutv6cQSLY',
                category: 'Loops'
            },
            {
                name: 'Overhand Knot',
                use: 'Basic stopper knot',
                description: 'The most basic of all knots, often used as a stopper knot or as the foundation for more complex knots.',
                howToTie: 'Make a loop and pass the end through it.',
                youtubeLink: 'https://www.youtube.com/watch?v=48SCla90Nd4',
                youtubeId: '48SCla90Nd4',
                category: 'Miscellaneous'
            },
            {
                name: 'Bowline on a Bight',
                use: 'Creating a loop in the middle of a rope',
                description: 'A method of creating a loop in the middle of a rope without using the ends. It\'s often used for rescue purposes.',
                howToTie: 'Fold the rope to create a bight, tie a bowline with the doubled rope.',
                youtubeLink: 'https://www.youtube.com/watch?v=JxCDDWU-RB8',
                youtubeId: 'JxCDDWU-RB8',
                category: 'Loops'
            },
            {
                name: 'Sheepshank',
                use: 'Temporarily shortening a rope',
                description: 'Used to shorten a rope without cutting it or for bypassing a frayed section. It\'s not a secure knot under load.',
                howToTie: 'Make three loops in the rope, then secure each end loop with a half hitch.',
                youtubeLink: 'https://www.youtube.com/watch?v=j_hmKwfafi8',
                youtubeId: 'j_hmKwfafi8',
                category: 'Miscellaneous'
            },
            {
                name: 'Two Half Hitches',
                use: 'Securing a rope to a post with adjustability',
                description: 'A knot commonly used to secure a rope to a post or ring. It is a simple and reliable knot.',
                howToTie: 'Pass the rope around the post, then tie two consecutive half hitches around the standing line.',
                youtubeLink: 'https://www.youtube.com/watch?v=RfFwnkeEHls',
                youtubeId: 'RfFwnkeEHls',
                category: 'Hitches'
            },
            {
                name: 'Lariat Knot (Honda)',
                use: 'Creating a lasso',
                description: 'This knot forms a non-slipping loop used to create a lasso. It\'s adjustable and holds its shape.',
                howToTie: 'Tie an overhand knot leaving a long end, then pass the long end through the knot to form a slip knot.',
                youtubeLink: 'https://www.youtube.com/watch?v=GgaLokcONhg',
                youtubeId: 'GgaLokcONhg',
                category: 'Miscellaneous'
            },
            {
                name: 'Trucker\'s Hitch',
                use: 'Creating mechanical advantage for tightening',
                description: 'Provides mechanical advantage for tightening loads. Excellent for securing cargo.',
                howToTie: 'Tie a slip knot partway along the rope, pass the end around anchor point and back through the slip knot loop, then secure with two half hitches.',
                youtubeLink: 'https://www.youtube.com/watch?v=T8dUP_xGa3g',
                youtubeId: 'T8dUP_xGa3g',
                category: 'Miscellaneous'
            }
        ]
    },
    {
        id: 'artificial-intelligence',
        title: 'Artificial Intelligence',
        category: 'Vocational',
        level: 2,
        year: 2014,
        institution: 'North American Division',
        summary: 'Explore the history, applications, and ethical considerations of AI, distinguishing between human and machine intelligence.',
        requirements: [
            'What is artificial intelligence?',
            'On your own or with a group, develop a chart board that outlines a brief history of artificial intelligence. Prepare and give an oral presentation on your activity.',
            'What is the ultimate goal of artificial intelligence research?',
            'What is an android?',
            'With regard to the field of artificial intelligence, be able to define the following terms: a. General intelligence, b. Social intelligence, c. Creativity, d. Learning, e. Motion, f. Planning, g. Perception, h. Heuristic, i. Pattern recognition, j. Neural network, k. Natural language processing, l. Knowledge engineering',
            'Give three real world examples of how artificial intelligence is used to help society.',
            'What are some of the limitations to artificial intelligence? Be able to explain at least three.',
            'What are some basic human abilities that artificial intelligence cannot exhibit?',
            'Give a basic definition of an expert system.',
            'What are some of the advantages of an expert system?',
            'Give a real world example of how an expert system is used in society.',
            'On your own or with a group, discuss the importance of artificial intelligence and the role it plays in society. Prepare and give an oral presentation on your findings.',
            'Based on your observations from the previous question, visit a location that has applied the use of artificial intelligence. Prepare and give an oral presentation on your activity.',
            'Discuss with a group several biblical passages that talk about human intelligence. Compare and contrast modern artificial intelligence with the intelligence God gave his created beings. Some texts include: Genesis 1:26, 27; Psalm 139; and Psalm 8:3-6.'
        ]
    },
    {
        id: 'backpacking',
        title: 'Backpacking',
        category: 'Recreation',
        level: 2,
        year: 1986,
        institution: 'General Conference',
        summary: 'Learn essential skills for multi-day hiking trips, including packing, route planning, and selecting appropriate gear.',
        requirements: [
            'Discuss with your instructor the meaning of the motto: “Take nothing but pictures and leave nothing but footprints.”',
            'Know the essentials of proper clothing, shoes, and rain gear to use in backpacking.',
            'Know the principles in selecting a good quality backpack. In an emergency, what might be used in place of a backpack?',
            'Know the essential items to be taken on a backpack trip.',
            'What kind of sleeping bag and pad are best for your camping area? Know at least three kinds of each that are available.',
            'Know how to pack a backpack properly.',
            'What types of food are best for backpacking? Visit a grocery store and list the foods found there that are suitable for backpacking. With your instructor: a. Prepare a menu for a weekend backpack trip using foods obtained from a grocery store. b. Learn the techniques of measuring, packaging, and labeling backpack foods for your trip. c. Make a trail snack.',
            'Know the prevention, symptoms, and first aid for: a. Sunburn, b. Blisters, c. Frostbite, d. Hypothermia, e. Heat stroke, f. Heat exhaustion, g. Snake bite, h. Cramps, i. Dehydration',
            'Have a First Aid Kit in your pack and know how to use it.',
            'According to your weight, what is the maximum number of pounds you should be allowed to carry?',
            'Know three ways to find direction without a compass. Demonstrate at least two.',
            'Show the proper way to put on and take off a backpack alone and with a partner.',
            'Participate in a weekend backpack trip of at least five miles and cook your own meals.'
        ]
    },
    {
        id: 'baking',
        title: 'Baking',
        category: 'Household Arts',
        level: 1,
        year: 1945,
        institution: 'General Conference',
        summary: 'Master the art of baking breads, cakes, and cookies while understanding the function of different ingredients.',
        requirements: [
            'Explain the difference in food value between whole wheat flour and white flour.',
            'Describe the effects of yeast in bread making.',
            'Give one Old Testament and one New Testament incident where leavening is mentioned.',
            'Prepare whole grain bread (can be wheat, rye, oatmeal, etc.)',
            'Prepare two of the following: a. Yeast biscuits, b. Unleavened bread, c. Bread sticks, d. Bagels, e. Vegetable bread',
            'Read what Ellen White wrote regarding the use of baking powder and baking soda.',
            'How do you test a cake for being done? How do you keep a cake from “falling”?',
            'Prepare two of the following: a. Cake from basic ingredients (any flavor), b. Cake from a cake mix (any flavor), c. Fruit or nut cake or loaf cake, d. Sponge cake',
            'Make one pie in each of the following categories: a. Baked, any fruit including lemon, b. Unbaked (baked pie shell only), fresh fruit, gelatin, etc.',
            'Make and bake one recipe of cookies. Make one recipe of refrigerator cookies. It is preferable to use wholesome ingredients such as fruit, oatmeal, nuts, etc.',
            'Prepare a recipe file for all the items required above and any others desired. See how many recipes you can find using fruit without large amounts of sugar.',
            'Give two examples of counsel by Ellen White regarding nutrition.'
        ]
    },
    {
        id: 'basic-sewing',
        title: 'Basic Sewing',
        category: 'Household Arts',
        level: 1,
        year: 1976,
        institution: 'General Conference',
        summary: 'Learn fundamental sewing techniques, including threading a needle, sewing buttons, and basic stitches.',
        requirements: [
            'Describe the proper use of the following: thimble, tape measure, scissors and shears, pinking shears, needles of various sizes and types.',
            'Become acquainted with the sewing machine in your home or school. Identify: balance wheel, thread take-up, pressure foot, pressure foot lifter, needle, feed dogs, bobbin, and control.',
            'Demonstrate how to properly thread and run the machine.',
            'Hem a towel, showing neat and even stitches.',
            'Demonstrate your ability to properly sew on buttons, snaps, hooks and eyes.',
            'Tell what is meant by selvage, bias, straight of goods, and crosswise of goods.',
            'Make a laundry bag for camping, or a similar simple item.'
        ]
    },
    {
        id: 'basic-rescue',
        title: 'Basic Rescue',
        category: 'Health & Science',
        level: 1,
        year: 1986,
        institution: 'General Conference',
        summary: 'Acquire potentially life-saving skills for emergency situations, including carrying victims and basic first aid.',
        requirements: [
            'What is the definition of an emergency rescue?',
            'Show how to safely rescue a person from the following situations: a. Being in contact with a live electric wire, b. A room filled with fumes or smoke, c. Clothes on fire, d. Drowning using a non-swimming rescue, e. An ice accident',
            'Show three ways of attracting and communicating with rescue aircraft.',
            'Know six indications for the need of an immediate rescue.',
            'Know six procedures to follow before moving a victim from a life threatening situation.',
            'Know five principles involved in moving a victim from a life-threatening situation.',
            'Know the proper ways to help a victim, without assistance, in the following ways: a. Pulling the victim, b. Lifting the victim, c. Assisting a victim in walking',
            'Know the proper way to help a victim, with assistance, in the following ways: a. Chair carry, b. Fore-and aft carry, c. Two-handed and four-handed seats, d. Blanket carry, e. Three-man hammock carry with victim in supine and prone position, f. Three or four-man lift, g. Six-man lift and carry',
            'Know how to properly use a stretcher and carry a victim on a stretcher. Know how to make an improvised litter.',
            'Know how to properly use ropes and knots as follows: a. Tie knots for joining ropes together, b. Tie knots for shortening a rope, c. Tie knots for use around a person for a rescue, d. Coil and accurately throw a light and a heavy 50-foot (15.2 m) rope',
            'What steps should be taken before reporting a lost person? What information will be needed when reporting a lost person? How is a search for a lost person conducted in a wilderness area?'
        ]
    },
    {
        id: 'basketball',
        title: 'Basketball',
        category: 'Recreation',
        level: 1,
        year: 1999,
        institution: 'North American Division',
        summary: 'Develop skills in dribbling, passing, and shooting, and learn the rules and sportsmanship of basketball.',
        requirements: [
            'Know the basic rules of basketball.',
            'What is the meaning of “good sportsmanship”?',
            'Define the following terms: a. Air ball, b. Backboard, c. Back court, d. Front court, e. Baseline, f. Block, g. Bounce pass, h. Double dribble, i. Dribbling, j. Fake, k. Fast break, l. Field Goal, m. Fouled out, n. Give and go, o. Inbound, p. Intentional Foul, q. Jump ball, r. The Key, s. Loose ball foul, t. Man to man, u. One and one, v. Perimeter, w. Pick, x. Press, y. Rebound, z. Shot, aa. Steal, ab. Team Fouls, ac. Trap, ad. Traveling, ae. Turnover, af. Zone Defense, ag. Center, ah. Forwards, ai. Guards, aj. Jump shot, ak. Lay up, al. Bank shot, am. Dunk, an. Hook shot, ao. Free throw, ap. Personal foul, aq. Charging, ar. Blocking, as. Technical foul, at. Three second violation, au. Five second rule, av. Ten second rule, aw. Back court violation, ax. Inbound violation, ay. League, az. Three point shot',
            'Demonstrate an understanding of the different skills required at each position.',
            'Demonstrate reasonable skill in the following areas: a. Shooting from the free throw line, b. Shooting from different positions around the basket, c. Dribbling, d. Passing',
            'Spend at least four hours helping a less skilled or younger player improve their skills.',
            'Play at least five games with family or friends. Show good sportsmanship during your practice and games.',
            'Write a one page report on a famous basketball player. Discuss why they are or are not a good Christian role model.',
            'Discuss with your Pathfinder leader, pastor, or teacher the problems facing a Seventh-day Adventist youth considering sports in jr. high, high school, and college. What alternatives are there that allow for continued activity in sports?',
            'Make a scale drawing of a basketball court properly laid out.'
        ]
    },
    {
        id: 'beekeeping',
        title: 'Beekeeping',
        category: 'Vocational',
        level: 2,
        year: 1929,
        institution: 'General Conference',
        summary: 'Understand the life cycle of bees, the structure of the hive, and the basics of honey production and apiary management.',
        requirements: [
            'Know a brief history of either beekeeping or honey.',
            'List five uses of each of the following: a. Honey, b. Beeswax, c. Propolis',
            'Name 10 foods that would be very difficult to grow if there were no honey bees.',
            'List the duties of the drone, the worker, and the queen bees.',
            'Describe how bees build combs. Why does the comb turn dark with age?',
            'What is meant by the following terms: a. Movable-frame hive, b. Crossed comb, c. Bee space, d. Swarming',
            'What is a smoker? What materials make good fuel for a smoker?',
            'What consideration should be given when choosing a hive location?',
            'How are honey bee diseases spread from hive to hive?',
            'What is robbing? Describe a robber bee.',
            'Name four ways to help prevent swarming. Why should swarming be prevented?',
            'What three requirements must be met for the colony to successfully weather a winter?',
            'What is the advantage of using a double-brood chamber system?',
            'Carry out the following duties of successful beekeeping: a. Spring feed to stimulate brood production, b. Supering and other swarm prevention techniques, c. Extract honey and put into jars, d. Fall feeding and “taking the hive down” to prepare it for the winter months',
            'How do you know when a frame is ready to be removed from the hive for extraction?'
        ]
    },
    {
        id: 'birds',
        title: 'Birds',
        category: 'Nature',
        level: 1,
        year: 1928,
        institution: 'General Conference',
        summary: 'Identify and observe various bird species, their habitats, and characteristics to appreciate their role in nature.',
        requirements: [
            'Give two characteristics that set birds apart from all other creatures.',
            'Name three flightless birds, tell what their diet consists of, and name the country or continent in which each one lives.',
            'Give the day of the week when birds were created. Find in the Bible the names of five birds and be able to name them from memory.',
            'Write or give orally three ways in which God’s love and purpose is shown in the creation of birds.',
            'Make a list of 30 species of wild birds, including birds from at least five different orders that you personally have observed and positively identified by sight out of doors.',
            'Make a list of five species of wild birds that you personally have positively identified by sound out of doors.',
            'Do one of the following: a. Set up a feeding station and report on the bird visitors observed for a period of seven days. b. Find a bird’s nest, identify the species of the bird that built it, describe the nest in detail, observe the nest for five days, and report what happened at the nest on each of the days. c. In the Western Hemisphere: Maintain a hummingbird feeder for two months. d. In other areas of the world: Select at least three different habitats in your area and make comparative bird lists of them indicating the differences in birds expected and found.'
        ]
    },
    {
        id: 'camping-skills-1',
        title: 'Camping Skills I',
        category: 'Recreation',
        level: 1,
        year: 1986,
        institution: 'General Conference',
        summary: 'Learn the basics of camping, including tent pitching, fire safety, and environmental stewardship.',
        requirements: [
            'Be in (at least) the 5th grade or 10 years old.',
            'Understand and practice wilderness and camping etiquette regarding preservation of the outdoors.',
            'Know eight things to do when lost.',
            'Be familiar with various types of sleeping equipment suitable to location and season.',
            'List personal items needed for a weekend campout.',
            'Plan and participate in a weekend camping trip.',
            'Know how to properly pitch and strike a tent. Observe fire precautions when tent is in use.',
            'Know and practice the proper principles for camp sanitation for both primitive and established campsites.',
            'Properly use the knife and hatchet. Know 10 safety rules for their use.',
            'Fires: a. Demonstrate ability to choose and prepare a fire site. b. Know fire safety precautions. c. Know how to properly strike a match. d. Practice building a fire with use of one match, using only natural materials.',
            'Demonstrate how to protect firewood in wet weather.',
            'Bake bread on a stick.',
            'Describe the proper procedures for washing and keeping the cooking and eating utensils clean.',
            'Describe sleeping wear and how to stay warm at night.',
            'Draw a spiritual object lesson from nature on your camping trip.',
            'Explain and practice the motto: “Take only pictures and leave only footprints.”'
        ]
    },
    {
        id: 'camping-skills-2',
        title: 'Camping Skills II',
        category: 'Recreation',
        level: 1,
        year: 1986,
        institution: 'General Conference',
        summary: 'Expand your camping expertise with advanced skills in campsite selection, sanitation, and outdoor living.',
        requirements: [
            'Be in (at least) the 6th grade or 11 years old.',
            'Develop a personal philosophy of outdoor etiquette, such as courtesy to other campers and outdoor conservation.',
            'Know and understand the following six W’s for the selection of a good campsite: Wind, Water, Wild things, Wood, Weather, Willingness.',
            'Demonstrate your ability to protect the wilderness and your water source by proper personal hygiene and cooking sanitation.',
            'Participate in a weekend campout.',
            'Take part in a camp worship service to include one of the following: Sabbath School lesson study, Story, Worship thought, Leading song service.',
            'Know how to safely light and use a camp stove and lantern.',
            'Know safety rules and demonstrate your ability to properly cut firewood.',
            'Demonstrate how to break dead wood properly.',
            'Using fuzz sticks or shaved sticks, build and know the use of a council or crisscross fire and one type of cooking fire. Review fire building safety rules.',
            'Explain two ways to keep camp food cool.',
            'Build two different camp cranes.',
            'Prepare camp meals using boiling, frying, and baking.',
            'Demonstrate tent site selection. Properly pitch and strike a tent. What precautions should be taken when striking a wet tent? Properly clean, dry, and store a tent.',
            'Bedding: Show proper ways to stuff or roll your sleeping bag or bed roll for travel. Tell how to keep a sleeping bag or bed roll dry on a camping trip. Describe how to properly clean your sleeping bag or bed roll.'
        ]
    },
    {
        id: 'community-service',
        title: 'Community Service',
        category: 'ADRA',
        level: 1,
        year: 2005,
        institution: 'General Conference',
        summary: 'Engage in meaningful service projects to support the local community and understand the biblical call to help others.',
        requirements: [
            'Read the following Bible texts and explain what you think God is asking us to do to help the poor and suffering in our community: a. Isaiah 58:3-12, b. Luke 10:25-37, c. Matthew 25:31-46',
            'Explain to your instructor 1) what the letters “ADRA” stand for and the difference between “development” and “relief”; 2) talk about a local organization that serves the poor and disadvantaged in your community and what services it provides.',
            'Meet with a community leader in your area and ask about projects that your Pathfinder unit could accomplish to help meet needs in your community.',
            'Plan, organize, and complete a community service project with your Pathfinder unit or class in your community. This project should target a certain need that your community has. Total time from planning to completion of this project should be approximately 10 hours.'
        ]
    },
    {
        id: 'computers',
        title: 'Computers',
        category: 'Vocational',
        level: 1,
        year: 1986,
        institution: 'General Conference',
        summary: 'Understand computer hardware, software, and basic operation, including word processing and safe internet usage.',
        requirements: [
            'Write 200 words or give a three-minute oral report about the history of computers.',
            'Define the following terms: a. Hardware, b. Software, c. Floppy Disk, d. Hard Drive, e. Mainframe, f. Desktop Computer, g. Laptop Computer, h. ROM, i. RAM, j. Alphanumeric, k. CPU, l. Circuit Board, m. Cursor, n. Port, o. Program, p. DOS or OS, q. CD Rom',
            'What are the proper handling and storage techniques of disks?',
            'Describe the function of and point out the following components of a personal computer: a. Keyboard, b. Monitor, c. Printer, d. System Unit or Central Processing Unit, e. Disk Drive',
            'Know the difference between and the uses for the following printers: a. Letter Quality, b. Dot Matrix, c. Laser, d. Plotter, e. Ink Jet, f. Thermal',
            'Show or describe how to protect a computer system from dust, dirt, static electricity, power surges and outages, or other potentially dangerous factors that could hamper or hurt a computer system.',
            'Name at least four input devices for computers.',
            'What does it mean to back up a disk or a file? Why is it important?',
            'What is computer preventive maintenance? Why is it important?',
            'Successfully boot, load (install), and use a prepared software program for use in a computer system. (No computer games.)',
            'Tell several ways an individual or family could use a personal computer other than for games.'
        ]
    },
    {
        id: 'cpr',
        title: 'CPR',
        category: 'Health & Science',
        level: 2,
        year: 1986,
        institution: 'General Conference',
        summary: 'Learn the vital life-saving technique of Cardiopulmonary Resuscitation.',
        requirements: [
            'Know and understand the location and function of the heart and lungs.',
            'Define CPR and tell five conditions under which it would be used.',
            'Successfully complete a class sponsored by either the American Heart Association, the Red Cross, or an equivalent under a certified instructor in order to properly learn and demonstrate one-person CPR. This must be within the past 12 months.',
            'Understand Prudent Heart Living. List five things a person can do to maintain a healthy heart.',
            'Develop, maintain, and keep a record of a personalized program in exercise, health, and diet habits for one month.',
            'Learn the significance of the colors and design used on the honor token for this honor as follows: a. The person needing CPR is white, signifying no circulation. b. The person giving CPR is red, signifying a very alive person. c. The border of gold speaks to the value of the human life. d. A heart is formed by the head, shoulders, and arms of the person performing the CPR, signifying compassion for another individual.'
        ]
    },
    {
        id: 'cultural-food',
        title: 'Cultural Food Preparation',
        category: 'Household Arts',
        level: 2,
        year: 2011,
        institution: 'South Pacific Division',
        summary: 'Explore culinary traditions from around the world by preparing and tasting authentic dishes.',
        requirements: [
            'Cook a meal using local methods and foods by yourself. See example below.',
            'Materials: 1. Raw foods (e.g. Dalo, cassava, yams, sweet potatoes, taro leaves, etc.) 2. Banana leaves or other leaves used in your area 3. Stones 4. Firewood 5. Banana stems 6. Coconut leaves',
            'Methods: 1. Light the fire first. 2. Pile the firewood in order (criss-cross method). 3. Put all the stones on top of the firewood. 4. Let the fire completely burn the wood until you notice that the stones are red-hot. 5. Clean the lovo/oven. 6. Put the smashed up banana stems on top of the stones. 7. Start to put all the raw foods on top of the banana stems. 8. Cover it up first with green coconut leaves before you completely cover it with leaves and leave it for one to one and a half hours. 9. Uncover the lovo/oven and the food is ready.'
        ]
    },
    {
        id: 'disaster-response',
        title: 'Disaster Response',
        category: 'ADRA',
        level: 1,
        year: 2005,
        institution: 'General Conference',
        summary: 'Prepare to assist in times of crisis by learning about disaster cycles, personal preparedness, and relief agencies.',
        requirements: [
            'Explain the type of damage most likely to occur to homes, individuals, and communities for each of the following major types of disaster, and indicate for each in which parts of the world it occurs most frequently: a. Hurricane/Typhoon/Cyclone, b. Tornado, c. Floods, d. Earthquake, e. Tsunami, f. Fires, g. War/Civil conflict',
            'Describe briefly the types of services that are provided to survivors of disasters in your country by ADRA, the government, or local emergency responders.',
            'Read a newspaper or ADRA news report (go to www.adra.org) concerning a recent disaster and discuss some important things to keep in mind when responding to a disaster or emergency.',
            'Explain what the letters “ADRA” stand for and which letter describes ADRA’s role as a disaster responder.',
            'Describe at least one of these disaster response organizations and how it can work with ADRA during an emergency: a. Red Cross, b. Adventist Community Services (ACS) in the U.S., c. United Nations High Commissioner for Refugees (UNHCR), d. World Food Programme (WFP)',
            'Explain the role of the government when a disaster occurs and identify the key government agency in your nation that manages emergency response.'
        ]
    },
    {
        id: 'dogs',
        title: 'Dogs',
        category: 'Nature',
        level: 1,
        year: 1950,
        institution: 'General Conference',
        summary: 'Study the history, breeds, and care of dogs, including training tips and understanding their behavior.',
        requirements: [
            'Give the scientific name of the dog family.',
            'Name five distinctive characteristics of the dog family.',
            'Identify from picture, or personal observation, five wild members of the dog family.',
            'Identify from picture or personal observation 25 different kinds of pedigree dogs.',
            'Name five contributions the dog family has made to man.',
            'Give the name of the smallest and largest breed of dogs.',
            'Write or describe orally the value of the following dogs to man: a. Seeing Eye, Saint Bernard, Shepherd, Collie, and Eskimo.',
            'Write or tell what special contribution dogs have made to man in wartime.',
            'Identify from pictures or personal observation five dogs that are classified as “toy” dogs.',
            'What is the only dog that has a wholly blue or black tongue?',
            'Which is the fastest running dog?',
            'Which member of the “toy” dogs has become the most popular?',
            'What dog has been especially helpful in tracking criminals?',
            'Write or tell a dog story.'
        ]
    },
    {
        id: 'drilling-marching',
        title: 'Drilling & Marching',
        category: 'Recreation',
        level: 1,
        year: 1976,
        institution: 'General Conference',
        summary: 'Develop discipline and teamwork through precise movements and formation drilling.',
        requirements: [
            'Explain five or more objectives of drill.',
            'Define: formation, line, rank, interval, column, file, distance, cover, flank, cadence',
            'Explain the actions in each of the following groups: a. At Ease, Stand At Ease, and Parade Rest. b. Mark Time, Quick Time, and Double Time. c. Hand Salute and Present Arms. d. Right (Left) Flank, and Column Right (Left)',
            'Properly execute the following basic movements: Attention, Parade Rest, Stand At Ease, At Ease, Dress Right Dress, Prayer Attention, Present Arms, Order Arms, Right Face, Left Face, About Face, Fall Out',
            'Properly execute the following movements: Mark Time, Forward March, Right Flank, Left Flank, Column Right (with column of threes or fours), Column Left, Rear March, Halt',
            'Explain and demonstrate how to use, display, and care for the national flag, including how to properly fold it.'
        ]
    },
    {
        id: 'gardening',
        title: 'Gardening',
        category: 'Outdoor Industries',
        level: 1,
        year: 1928,
        institution: 'General Conference',
        summary: 'Learn to cultivate plants, understand soil health, and grow vegetables or flowers successfully.',
        requirements: [
            'Prepare soil, fertilize, and plant a vegetable plot of not less than 100 square feet. Grow at least six different vegetables, three from seeds and three from seedlings, through harvesting.',
            'List ways to control insects and/or disease in your garden. Know when and how to apply insecticides and fungicides.',
            'What is mulch? How and why is it used in the garden?',
            'What is hardiness? Which vegetables are considered hardy in your area?',
            'Do one of the following: a. Test germination for 100 of the same kind of seeds. b. Make and use a hotbed or cold frame. c. Prepare any three vegetables for market. d. Make and use a storage bin or pit for your vegetables.'
        ]
    },
    {
        id: 'hiking',
        title: 'Hiking',
        category: 'Recreation',
        level: 1,
        year: 1933,
        institution: 'General Conference',
        summary: 'Enjoy the outdoors while learning about trail safety, proper footwear, and navigation.',
        requirements: [
            'Explain and demonstrate the main points of good hiking practice, such as pacing, speed, resting, and etiquette.',
            'Explain the importance and method of proper foot care with regard to cleanliness, care of nails, socks, shoe selection, and first aid of tender or blistered feet.',
            'Make a list of proper clothing to be worn on a hike in both hot and cool weather.',
            'Make a list of needed gear for a long day hike in the wilderness and a short country hike.',
            'List five safety and courtesy rules to be used in wilderness trail hiking and road hiking.',
            'Explain the importance of drinking water and list three signs of contaminated water.',
            'Explain the importance of proper eating while hiking.',
            'Describe proper clothing and foot gear for cold and hot wet weather hiking.',
            'Submit a written plan for a 10-mile hike that includes: map route, clothing list, equipment list, and water and/or food.',
            'Use a topographical map and/or a road map in planning and doing one of the hikes in requirement #11.',
            'Have the following hiking record: a. One five-mile (8 km) rural or town hike. b. One five-mile ( 8 km) hike on a wilderness trail. c. Two 10-mile (16.1 km) day hikes on different routes. d. One 15-mile (24.2 km) hike on a wilderness trail. e. Within a month of each hike, write a short report, giving dates, routes covered, weather, and any interesting things you saw.'
        ]
    },
    {
        id: 'journalism',
        title: 'Journalism',
        category: 'Vocational',
        level: 2,
        year: 1938,
        institution: 'General Conference',
        summary: 'Learn the basics of reporting, writing, and editing news stories for various media platforms.',
        requirements: [
            'Describe the elements of a good lead paragraph and the use and importance of headlines.',
            'Write a news article of at least three paragraphs using a good lead paragraph about something interesting that has happened in your church, school, home, or Pathfinder Club.',
            'What are the essentials for writing a good story?',
            'Know the difference between passive and active verbs, and give three comparative examples.',
            'Write to a publisher, requesting story-writing guidelines.',
            'Write a story on one of the following: a. How your family first accepted Christ. b. Personal experiences of answered prayer or divine guidance. c. An interesting pet that you have had. d. An experience you have had while at summer camp or on a camping trip. e. When God first became real to you as a friend and personal Savior. f. The most difficult thing about being a Christian today.',
            'Submit a story or article to a Seventh-day Adventist publication.',
            'Know how to write a cover letter to the editor for submitting your story or article and write a cover letter to the editor to include with your story or article.',
            'What education is helpful for getting into the career of journalism?',
            'What types of jobs are available for anyone who is interested in journalism?'
        ]
    },
    {
        id: 'junior-youth-leadership',
        title: 'Junior Youth Leadership',
        category: 'Spiritual Growth, Outreach & Heritage',
        level: 3,
        year: 1945,
        institution: 'General Conference',
        summary: 'Develop leadership potential by assisting with club activities and mentoring younger members.',
        requirements: [
            'Be a Master Guide.',
            'Read two books on adolescent development or leadership.',
            'Serve in any one of the following offices for one year: a. AY leader or associate leader. b. Primary, Junior, Earliteen, or Youth Sabbath School leader. c. Staff member in an active Pathfinder Club. d. Staff member at a summer youth camp for a full summer program.',
            'Prepare a group to be invested in one of the Pathfinder Classes during the current year and assist in conducting the Investiture service.',
            'Know at least 10 qualities of a good youth leader.',
            'Know the difference between juniors (10-12 year olds) and teens (13-15 year olds) in the following areas: a. Physical, b. Emotional, c. Mental, d. Spiritual.',
            'Know principles in the proper administration of discipline to youth. Learn the following areas of discipline: a. Internal discipline, b. External discipline, c. Ten ways to prevent need for external discipline, d. Five types of discipline procedures.'
        ]
    },
    {
        id: 'kayaking',
        title: 'Kayaking',
        category: 'Recreation',
        level: 1,
        year: 1986,
        institution: 'South Pacific Division',
        summary: 'Master paddling techniques, safety procedures, and equipment care for recreational kayaking.',
        requirements: [
            'Satisfy the examiner that you have knowledge of different types of kayaks (Slalom, river, touring, sea); the uses for each and the equipment necessary for safe kayaking (helmet, life jacket, sprayskirt, bow and stern loops, flotation in kayak).',
            'Demonstrate an ability to enter and exit a kayak.',
            'Demonstrate ability to complete the following strokes: a. Straight forward and backward paddle. b. Left and right turn by forward and back paddling. c. Draw (sweep) stroke. d. Support stroke. e. Cross current paddling.',
            'Explain the steps involved in Eskimo rolling and demonstrate the proper method of doing this.',
            'Explain how to repair a hole in fiberglass.',
            'After completing a minimum of two training sessions, complete either: a. An overnight kayak trip. b. Two day trips (one including some white water).'
        ]
    },
    {
        id: 'laundering',
        title: 'Laundering',
        category: 'Household Arts',
        level: 1,
        year: 1928,
        institution: 'General Conference',
        summary: 'Learn proper fabric care, stain removal, and washing techniques for different types of clothing.',
        requirements: [
            'Why is it important to read the labels in garments before laundering them?',
            'What is the proper way to prepare clothes for washing?',
            'What types of clothes should be washed in hot, warm, and cold water?',
            'What precaution should be used when using chlorine bleach? What are the advantages of powdered oxygen bleach? Why should chlorine bleach and ammonia never be mixed?',
            'What precautions should be taken when using fabric softeners?',
            'What points are to be considered in selecting a washing machine, ironing machine, dryer, iron? How should these laundry implements be cared for?',
            'How are woolen garments laundered?',
            'Know how to remove stains: ink, fruit, rust, grass, cocoa, grease, blood, chewing gum. Why must stains be removed before laundering?',
            'Why is it important to remove garments from dryer immediately when the cycle is completed?',
            'What type of materials should be dried only on the lowest heat settings of a dryer?',
            'Show a blouse or shirt that you have ironed and folded, or show a skirt and coat that you have pressed.',
            'Properly launder and fold clothes for your family for one week.'
        ]
    },
    {
        id: 'lego-design',
        title: 'LEGO Design',
        category: 'Arts & Crafts',
        level: 1,
        year: 2013,
        institution: 'North American Division',
        summary: 'Express creativity and engineering skills by designing and building original structures with Lego bricks.',
        requirements: [
            'Know the following terms: a. Element, b. Stud, c. Brick, d. Plate, e. Base Plate, f. Tile, g. Slope, h. Inverted Slope, i. Hinge, j. Technics Brick, k. Power Functions, l. Mini-figure',
            'Build and/or find examples of following types of scale models: a. Micro Scale, b. Mini-figure Scale, c. Ultimate Collector Scale, d. 1 to 1 Scale',
            'Choose one of the following: a. Build a 1 to 1 scale model of something from nature, your home, church, or school. b. Build a scale model of your house, apartment, or other building in your community.',
            'Choose one of the following: a. Use LEGO® as visual aid in a Children’s Story for youth ages 2-9. b. Use LEGO® as part of a school project.',
            'Build a scene or an item from the Bible using LEGO® in one of the scale sizes from Requirement #2.',
            'From your imagination create your own design in 2 of the 5 categories (Car/truck, Plane/helicopter, Ship/submarine, Animal/plant, Machine/robot) and share both designs with your group or club.',
            'Write a 250 word paragraph, or in a 3-5 minute presentation to you group or club, tell how you can use LEGO® to witness to those that don’t know about God.'
        ]
    },
    {
        id: 'cpr',
        title: 'CPR',
        category: 'Health & Science',
        level: 2,
        year: 1986,
        institution: 'General Conference',
        summary: 'Learn the vital life-saving technique of Cardiopulmonary Resuscitation.',
        requirements: [
            'Know and understand the location and function of the heart and lungs.',
            'Define CPR and tell five conditions under which it would be used.',
            'Successfully complete a class sponsored by either the American Heart Association, the Red Cross, or an equivalent under a certified instructor in order to properly learn and demonstrate one-person CPR. This must be within the past 12 months.',
            'Understand Prudent Heart Living. List five things a person can do to maintain a healthy heart.',
            'Develop, maintain, and keep a record of a personalized program in exercise, health, and diet habits for one month.',
            'Learn the significance of the colors and design used on the honor token for this honor as follows: a. The person needing CPR is white, signifying no circulation. b. The person giving CPR is red, signifying a very alive person. c. The border of gold speaks to the value of the human life. d. A heart is formed by the head, shoulders, and arms of the person performing the CPR, signifying compassion for another individual.'
        ]
    },
    {
        id: 'cultural-food',
        title: 'Cultural Food Preparation',
        category: 'Household Arts',
        level: 2,
        year: 2011,
        institution: 'South Pacific Division',
        summary: 'Explore culinary traditions from around the world by preparing and tasting authentic dishes.',
        requirements: [
            'Cook a meal using local methods and foods by yourself. See example below.',
            'Materials: 1. Raw foods (e.g. Dalo, cassava, yams, sweet potatoes, taro leaves, etc.) 2. Banana leaves or other leaves used in your area 3. Stones 4. Firewood 5. Banana stems 6. Coconut leaves',
            'Methods: 1. Light the fire first. 2. Pile the firewood in order (criss-cross method). 3. Put all the stones on top of the firewood. 4. Let the fire completely burn the wood until you notice that the stones are red-hot. 5. Clean the lovo/oven. 6. Put the smashed up banana stems on top of the stones. 7. Start to put all the raw foods on top of the banana stems. 8. Cover it up first with green coconut leaves before you completely cover it with leaves and leave it for one to one and a half hours. 9. Uncover the lovo/oven and the food is ready.'
        ]
    },
    {
        id: 'disaster-response',
        title: 'Disaster Response',
        category: 'ADRA',
        level: 1,
        year: 2005,
        institution: 'General Conference',
        summary: 'Prepare to assist in times of crisis by learning about disaster cycles, personal preparedness, and relief agencies.',
        requirements: [
            'Explain the type of damage most likely to occur to homes, individuals, and communities for each of the following major types of disaster, and indicate for each in which parts of the world it occurs most frequently: a. Hurricane/Typhoon/Cyclone, b. Tornado, c. Floods, d. Earthquake, e. Tsunami, f. Fires, g. War/Civil conflict',
            'Describe briefly the types of services that are provided to survivors of disasters in your country by ADRA, the government, or local emergency responders.',
            'Read a newspaper or ADRA news report (go to www.adra.org) concerning a recent disaster and discuss some important things to keep in mind when responding to a disaster or emergency.',
            'Explain what the letters “ADRA” stand for and which letter describes ADRA’s role as a disaster responder.',
            'Describe at least one of these disaster response organizations and how it can work with ADRA during an emergency: a. Red Cross, b. Adventist Community Services (ACS) in the U.S., c. United Nations High Commissioner for Refugees (UNHCR), d. World Food Programme (WFP)',
            'Explain the role of the government when a disaster occurs and identify the key government agency in your nation that manages emergency response.'
        ]
    },
    {
        id: 'dogs',
        title: 'Dogs',
        category: 'Nature',
        level: 1,
        year: 1950,
        institution: 'General Conference',
        summary: 'Study the history, breeds, and care of dogs, including training tips and understanding their behavior.',
        requirements: [
            'Give the scientific name of the dog family.',
            'Name five distinctive characteristics of the dog family.',
            'Identify from picture, or personal observation, five wild members of the dog family.',
            'Identify from picture or personal observation 25 different kinds of pedigree dogs.',
            'Name five contributions the dog family has made to man.',
            'Give the name of the smallest and largest breed of dogs.',
            'Write or describe orally the value of the following dogs to man: a. Seeing Eye, Saint Bernard, Shepherd, Collie, and Eskimo.',
            'Write or tell what special contribution dogs have made to man in wartime.',
            'Identify from pictures or personal observation five dogs that are classified as “toy” dogs.',
            'What is the only dog that has a wholly blue or black tongue?',
            'Which is the fastest running dog?',
            'Which member of the “toy” dogs has become the most popular?',
            'What dog has been especially helpful in tracking criminals?',
            'Write or tell a dog story.'
        ]
    },
    {
        id: 'drilling-marching',
        title: 'Drilling & Marching',
        category: 'Recreation',
        level: 1,
        year: 1976,
        institution: 'General Conference',
        summary: 'Develop discipline and teamwork through precise movements and formation drilling.',
        requirements: [
            'Explain five or more objectives of drill.',
            'Define: formation, line, rank, interval, column, file, distance, cover, flank, cadence',
            'Explain the actions in each of the following groups: a. At Ease, Stand At Ease, and Parade Rest. b. Mark Time, Quick Time, and Double Time. c. Hand Salute and Present Arms. d. Right (Left) Flank, and Column Right (Left)',
            'Properly execute the following basic movements: Attention, Parade Rest, Stand At Ease, At Ease, Dress Right Dress, Prayer Attention, Present Arms, Order Arms, Right Face, Left Face, About Face, Fall Out',
            'Properly execute the following movements: Mark Time, Forward March, Right Flank, Left Flank, Column Right (with column of threes or fours), Column Left, Rear March, Halt',
            'Explain and demonstrate how to use, display, and care for the national flag, including how to properly fold it.'
        ]
    },
    {
        id: 'gardening',
        title: 'Gardening',
        category: 'Outdoor Industries',
        level: 1,
        year: 1928,
        institution: 'General Conference',
        summary: 'Learn to cultivate plants, understand soil health, and grow vegetables or flowers successfully.',
        requirements: [
            'Prepare soil, fertilize, and plant a vegetable plot of not less than 100 square feet. Grow at least six different vegetables, three from seeds and three from seedlings, through harvesting.',
            'List ways to control insects and/or disease in your garden. Know when and how to apply insecticides and fungicides.',
            'What is mulch? How and why is it used in the garden?',
            'What is hardiness? Which vegetables are considered hardy in your area?',
            'Do one of the following: a. Test germination for 100 of the same kind of seeds. b. Make and use a hotbed or cold frame. c. Prepare any three vegetables for market. d. Make and use a storage bin or pit for your vegetables.'
        ]
    },
    {
        id: 'hiking',
        title: 'Hiking',
        category: 'Recreation',
        level: 1,
        year: 1933,
        institution: 'General Conference',
        summary: 'Enjoy the outdoors while learning about trail safety, proper footwear, and navigation.',
        requirements: [
            'Explain and demonstrate the main points of good hiking practice, such as pacing, speed, resting, and etiquette.',
            'Explain the importance and method of proper foot care with regard to cleanliness, care of nails, socks, shoe selection, and first aid of tender or blistered feet.',
            'Make a list of proper clothing to be worn on a hike in both hot and cool weather.',
            'Make a list of needed gear for a long day hike in the wilderness and a short country hike.',
            'List five safety and courtesy rules to be used in wilderness trail hiking and road hiking.',
            'Explain the importance of drinking water and list three signs of contaminated water.',
            'Explain the importance of proper eating while hiking.',
            'Describe proper clothing and foot gear for cold and hot wet weather hiking.',
            'Submit a written plan for a 10-mile hike that includes: map route, clothing list, equipment list, and water and/or food.',
            'Use a topographical map and/or a road map in planning and doing one of the hikes in requirement #11.',
            'Have the following hiking record: a. One five-mile (8 km) rural or town hike. b. One five-mile ( 8 km) hike on a wilderness trail. c. Two 10-mile (16.1 km) day hikes on different routes. d. One 15-mile (24.2 km) hike on a wilderness trail. e. Within a month of each hike, write a short report, giving dates, routes covered, weather, and any interesting things you saw.'
        ]
    },
    {
        id: 'journalism',
        title: 'Journalism',
        category: 'Vocational',
        level: 2,
        year: 1938,
        institution: 'General Conference',
        summary: 'Learn the basics of reporting, writing, and editing news stories for various media platforms.',
        requirements: [
            'Describe the elements of a good lead paragraph and the use and importance of headlines.',
            'Write a news article of at least three paragraphs using a good lead paragraph about something interesting that has happened in your church, school, home, or Pathfinder Club.',
            'What are the essentials for writing a good story?',
            'Know the difference between passive and active verbs, and give three comparative examples.',
            'Write to a publisher, requesting story-writing guidelines.',
            'Write a story on one of the following: a. How your family first accepted Christ. b. Personal experiences of answered prayer or divine guidance. c. An interesting pet that you have had. d. An experience you have had while at summer camp or on a camping trip. e. When God first became real to you as a friend and personal Savior. f. The most difficult thing about being a Christian today.',
            'Submit a story or article to a Seventh-day Adventist publication.',
            'Know how to write a cover letter to the editor for submitting your story or article and write a cover letter to the editor to include with your story or article.',
            'What education is helpful for getting into the career of journalism?',
            'What types of jobs are available for anyone who is interested in journalism?'
        ]
    },
    {
        id: 'junior-youth-leadership',
        title: 'Junior Youth Leadership',
        category: 'Spiritual Growth, Outreach & Heritage',
        level: 3,
        year: 1945,
        institution: 'General Conference',
        summary: 'Develop leadership potential by assisting with club activities and mentoring younger members.',
        requirements: [
            'Be a Master Guide.',
            'Read two books on adolescent development or leadership.',
            'Serve in any one of the following offices for one year: a. AY leader or associate leader. b. Primary, Junior, Earliteen, or Youth Sabbath School leader. c. Staff member in an active Pathfinder Club. d. Staff member at a summer youth camp for a full summer program.',
            'Prepare a group to be invested in one of the Pathfinder Classes during the current year and assist in conducting the Investiture service.',
            'Know at least 10 qualities of a good youth leader.',
            'Know the difference between juniors (10-12 year olds) and teens (13-15 year olds) in the following areas: a. Physical, b. Emotional, c. Mental, d. Spiritual.',
            'Know principles in the proper administration of discipline to youth. Learn the following areas of discipline: a. Internal discipline, b. External discipline, c. Ten ways to prevent need for external discipline, d. Five types of discipline procedures.'
        ]
    },
    {
        id: 'kayaking',
        title: 'Kayaking',
        category: 'Recreation',
        level: 1,
        year: 1986,
        institution: 'South Pacific Division',
        summary: 'Master paddling techniques, safety procedures, and equipment care for recreational kayaking.',
        requirements: [
            'Satisfy the examiner that you have knowledge of different types of kayaks (Slalom, river, touring, sea); the uses for each and the equipment necessary for safe kayaking (helmet, life jacket, sprayskirt, bow and stern loops, flotation in kayak).',
            'Demonstrate an ability to enter and exit a kayak.',
            'Demonstrate ability to complete the following strokes: a. Straight forward and backward paddle. b. Left and right turn by forward and back paddling. c. Draw (sweep) stroke. d. Support stroke. e. Cross current paddling.',
            'Explain the steps involved in Eskimo rolling and demonstrate the proper method of doing this.',
            'Explain how to repair a hole in fiberglass.',
            'After completing a minimum of two training sessions, complete either: a. An overnight kayak trip. b. Two day trips (one including some white water).'
        ]
    },
    {
        id: 'laundering',
        title: 'Laundering',
        category: 'Household Arts',
        level: 1,
        year: 1928,
        institution: 'General Conference',
        summary: 'Learn proper fabric care, stain removal, and washing techniques for different types of clothing.',
        requirements: [
            'Why is it important to read the labels in garments before laundering them?',
            'What is the proper way to prepare clothes for washing?',
            'What types of clothes should be washed in hot, warm, and cold water?',
            'What precaution should be used when using chlorine bleach? What are the advantages of powdered oxygen bleach? Why should chlorine bleach and ammonia never be mixed?',
            'What precautions should be taken when using fabric softeners?',
            'What points are to be considered in selecting a washing machine, ironing machine, dryer, iron? How should these laundry implements be cared for?',
            'How are woolen garments laundered?',
            'Know how to remove stains: ink, fruit, rust, grass, cocoa, grease, blood, chewing gum. Why must stains be removed before laundering?',
            'Why is it important to remove garments from dryer immediately when the cycle is completed?',
            'What type of materials should be dried only on the lowest heat settings of a dryer?',
            'Show a blouse or shirt that you have ironed and folded, or show a skirt and coat that you have pressed.',
            'Properly launder and fold clothes for your family for one week.'
        ]
    },
    {
        id: 'lego-design',
        title: 'LEGO Design',
        category: 'Arts & Crafts',
        level: 1,
        year: 2013,
        institution: 'North American Division',
        summary: 'Express creativity and engineering skills by designing and building original structures with Lego bricks.',
        requirements: [
            'Know the following terms: a. Element, b. Stud, c. Brick, d. Plate, e. Base Plate, f. Tile, g. Slope, h. Inverted Slope, i. Hinge, j. Technics Brick, k. Power Functions, l. Mini-figure',
            'Build and/or find examples of following types of scale models: a. Micro Scale, b. Mini-figure Scale, c. Ultimate Collector Scale, d. 1 to 1 Scale',
            'Choose one of the following: a. Build a 1 to 1 scale model of something from nature, your home, church, or school. b. Build a scale model of your house, apartment, or other building in your community.',
            'Choose one of the following: a. Use LEGO® as visual aid in a Children’s Story for youth ages 2-9. b. Use LEGO® as part of a school project.',
            'Build a scene or an item from the Bible using LEGO® in one of the scale sizes from Requirement #2.',
            'From your imagination create your own design in 2 of the 5 categories (Car/truck, Plane/helicopter, Ship/submarine, Animal/plant, Machine/robot) and share both designs with your group or club.',
            'Write a 250 word paragraph, or in a 3-5 minute presentation to you group or club, tell how you can use LEGO® to witness to those that don’t know about God.'
        ]
    },
    {
        id: 'literature-evangelism',
        title: 'Literature Evangelism',
        category: 'Spiritual Growth, Outreach & Heritage',
        level: 1,
        year: 1938,
        institution: 'General Conference',
        summary: 'Share the gospel through the distribution of Christian literature and books.',
        requirements: [
            'From the Bible and the Spirit of Prophecy, write a summary, at least 250 words in length, on the importance of the use of literature in leading people to Christ.',
            'Name five essential qualifications of a literature evangelist.',
            'How is the literature evangelist supported?',
            'What four steps are taken in the sale of a book or a magazine?',
            'Briefly outline how to arouse an interest in purchasing a book or magazine.',
            'Know how to meet objections to purchasing a book or magazine.',
            'Do one of the following: a. Maintain a literature rack for four months, keeping a log of which books are the most and least popular. b. Do a project of house-to-house or mail distribution of literature in your community for 10 hours. c. Engage in selling Seventh-day Adventist books and/or magazines during a period of at least five weeks, for at least 20 hours each. d. Do a project of distributing religious books to local government officials. e. Do a project of supplying religious literature to patients in a hospital or nursing home. f. Make a project of supplying a year’s subscription to Liberty magazine to the judges and/or lawyers in your community. g. Make a project of sending literature/or Bibles to the mission field.'
        ]
    },
    {
        id: 'origami',
        title: 'Origami',
        category: 'Arts & Crafts',
        level: 1,
        year: 1997,
        institution: 'General Conference',
        summary: 'Explore the Japanese art of paper folding to create intricate figures and shapes.',
        requirements: [
            'What is Origami? Where did it come from? How was it used and developed?',
            'Identify the symbols for the following terms: a. Valley fold, b. Mountain fold, c. Cut, d. Existing crease, e. Hold here, f. Watch this spot, g. In front, h. Behind, i. Tuck in, open or apply force, j. Fold over and over, k. Turn model over',
            'Demonstrate folding the following folds: a. Reverse fold, b. Squash fold, c. Petal fold, d. Book fold, e. Preliminary fold, f. Blintz',
            'Demonstrate folding the following bases: a. Bird base, b. Waterbomb base, c. Frog base',
            'Fold the following models: a. House, b. Lotus blossom, c. Cicada, d. Housefly, e. Butterfly',
            'Choose four of the following models to fold or select similar models from Origami books: a. Jumping Frog, b. Carrier Pigeon, c. Sailboat, d. Hen, e. Leaf, f. Walking dog, g. Duck',
            'Fold one model of your choice from memory from requirement #5 or #6.',
            'Illustrate a Bible story using several Origami models.'
        ]
    },
    {
        id: 'photography',
        title: 'Photography',
        category: 'Arts & Crafts',
        level: 2,
        year: 1928,
        institution: 'General Conference',
        summary: 'Learn the principles of composition, lighting, and camera operation to capture compelling images.',
        requirements: [
            'Explain the principles of camera construction, what the camera lens does, the effect of light upon the sensitive film, and the action of developers.',
            'What is meant by the “speed” of the film? What does ASA/ISO mean?',
            'How are shutter speed, lens aperature, and film speed related?',
            'Give the principal uses of photography.',
            'Take print or slide pictures illustrating at least eight of the following techniques. Use comparison pictures for illustration: a. Framing, b. Camera steadiness, c. Direction of lighting, d. Panning, e. Rule of thirds, f. Angle, g. Level horizon, h. Distance from subject, i. Use of leading lines, j. Quality of light, k. Correct exposure, l. Use of flash',
            'Do one of the following: a. Tell how black and white film is developed into negatives and how prints are made. b. Develop and print eight of your own pictures, explaining each step.'
        ]
    },
    {
        id: 'physical-fitness',
        title: 'Physical Fitness',
        category: 'Recreation',
        level: 2,
        year: 1929,
        institution: 'General Conference',
        summary: 'Improve overall health through a balanced program of exercise, diet, and rest.',
        requirements: [
            'List 10 benefits of being physically fit.',
            'Know how the following help to achieve a balance for your body: a. Exercise, b. Proper eating, c. Emotional stability',
            'Define the following exercises: a. Isometric, b. Isotonic, c. Isokinetic, d. Anaerobic, e. Aerobic',
            'Know the meaning of the principles involved in the following exercises: a. Warm up, b. Aerobic exercises, c. Cool down, d. Calisthenics',
            'Know how to determine your heart rate at rest and after exercise.',
            'Know how to determine the minimum rate at which your heart should be beating to obtain the best aerobic conditioning effect.',
            'Using the four steps given in requirement #4, do a regular exercise program at least four times a week for three months. Keep a chart of the following: a. Type of warm-up exercises, b. Type of aerobic exercises, c. How long aerobic exercises were performed, d. Type of calisthenics performed. Maintain minimum heart rate for 20 minutes.'
        ]
    },
    {
        id: 'pizza-maker',
        title: 'Pizza Maker',
        category: 'Household Arts',
        level: 1,
        year: 2014,
        institution: 'Inter-European Division',
        summary: 'Learn to make pizza from scratch, including dough preparation and topping selection.',
        requirements: [
            'Do a short research on the history of pizza.',
            'Make a list of the basic ingredients for the pizza dough.',
            'Find out at least one biblical text about each single ingredient. Explain at least 4 of these texts and their symbolic meaning.',
            'Describe the leavening process.',
            'What is the difference between Neapolitan style pizza and Roman style pizza?',
            'According to its shape and size, how many kinds of pizza do you know?',
            'What are three different ways to bake a pizza. Describe the differences in detail.',
            'What is the ideal temperature if you use a wood oven to cook pizza? What is the ideal temperature if you use an electric oven?',
            'Prepare a Pizza Margherita.'
        ]
    },
    {
        id: 'prayer',
        title: 'Prayer',
        category: 'Spiritual Growth, Outreach & Heritage',
        level: 1,
        year: 2011,
        institution: 'North American Division',
        summary: 'Deepen your connection with God through understanding and practicing different forms of prayer.',
        requirements: [
            'As a group or with a friend discuss: a. What do you think prayer is? b. Why do you believe prayer is important? c. Do you think a person can be a Christian and not pray?',
            'Individually or as a group, examine the two versions of the Lord’s Prayer (Matthew 6:9-13 and Luke 11:2-4) found in the gospels.',
            'Locate six (6) prayers in the Bible (at least two of Jesus’ and two in the Old Testament), then: a. Read / listen to each prayer, b. Discover who prayed, what they prayed for, and why they prayed, c. Discover the result of each prayer',
            'Learn the A C T S for prayer and list an example of a prayer of each type in the Bible. (Adoration, Confession, Thanksgiving, Supplication)',
            'As a group or with a friend, read / listen to and discuss the chapter on Prayer in the book, Steps to Christ.',
            'As a group or with a friend, discuss how you have seen God answer personal prayer.',
            'Develop a personal prayer life by praying daily for a month for: a. A mission / missionary, b. Person(s) who are ill, c. A church or school leader, d. An issue(s) affecting the neighbors of your community.',
            'Pray with someone that has a physical, emotional, or spiritual need.'
        ]
    },
    {
        id: 'sign-language',
        title: 'Sign Language',
        category: 'Spiritual Growth, Outreach & Heritage',
        level: 1,
        year: 1978,
        institution: 'General Conference',
        summary: 'Learn basic communication skills for the deaf, including the manual alphabet and common phrases.',
        requirements: [
            'Learn the manual alphabet used by the deaf.',
            'Have a minimum of three hours of instruction in signing.',
            'Send and receive finger spelling at the rate of five words per minute, using a minimum of 25 letters.',
            'Learn at least 100 signs from one or more reference books on signing.',
            'Learn and present in sign language (not finger spelling) at least two simple songs.',
            'Do one of the following: a. Explain the difference between Ameslam and sign English and demonstrate the use of both. b. Read and give an oral or written report on a school in your country or state specializing in deaf education.'
        ]
    },
    {
        id: 'soccer',
        title: 'Soccer',
        category: 'Recreation',
        level: 1,
        year: 1989,
        institution: 'North American Division',
        summary: 'Develop stamina and coordination while learning soccer rules and team strategies.',
        requirements: [
            'Know the basic rules of soccer.',
            'What is the meaning of “good sportsmanship”?',
            'Make a drawing of the soccer playing field.',
            'Demonstrate reasonable skill in playing the game of soccer.',
            'Describe the different skills required at each position.',
            'Know the meaning of and the referee signals for the following: a. Off sides, b. Holding, c. Corner kick, d. Indirect kick, e. Direct kick, f. Goal',
            'Define the following terms: Advantage, Booking, Clearing, Corner Arcs, Cross, Dribble, Drop ball, Drop kick, Dummy, Half volley, Touch, Volley, Heading, Juggling, Marking, Nutmeg, Out-of-bounds, Pass back, Penalty area, Slide tackle, Tackle, Throw, Trapping, Wall',
            'Spend at least four hours helping less skilled or younger players improve their skills.',
            'Play at least five games with family or friends. Show good sportsmanship during your practice and games.',
            'Write a one page report on a famous soccer player. Discuss why they are or are not a good Christian role model.',
            'Discuss with your Pathfinder leader, pastor, or teacher the problems facing a Seventh-day Adventist youth considering sports in jr. high, high school, or college.'
        ]
    },
    {
        id: 'social-media',
        title: 'Social Media',
        category: 'Vocational',
        level: 2,
        year: 2014,
        institution: 'North American Division',
        summary: 'Understand the positive and negative aspects of social media and how to use it responsibly.',
        requirements: [
            'What is social media?',
            'Define the following types of social media. Give a current example of each one as applicable: Internet forum, Text messaging, Social network service, Social blogs, Podcast, Social bookmarking',
            'What are some distinct advantages of using social media?',
            'What are the disadvantages, dangers and pitfalls of using social media?',
            'Discuss with a group the importance of maintaining your integrity when posting information about yourself as well as responding to posted information about others.',
            'Discuss with a group how social media can be used to engage different types of learners.',
            'Discuss what each of the following passages say about communications (social media): Matthew 24:14, Matthew 28:19, Ephesians 4:29, Proverbs 15:28',
            'Read Philippians 2 concerning the character of Jesus Christ. Review your social media profile to see if it reflects those characteristics.',
            'Create a presentation, speech or game that shows what you have learned about social media while earning this honor.',
            'If your church or Pathfinder club uses social media for advertising, assist with an update and learn the process.'
        ]
    },
    {
        id: 'swimming',
        title: 'Swimming',
        category: 'Recreation',
        level: 2,
        year: 1929,
        institution: 'General Conference',
        summary: 'Learn essential water safety and swimming strokes for fitness and survival.',
        requirements: [
            'Complete the Red Cross Swim level VI--Skills Proficiency or the following:',
            'Demonstrate approach and hurdle on the diving board.',
            'Demonstrate jump tuck from diving board.',
            'Swim front crawl stroke—100 yards.',
            'Swim back crawl stroke—100 yards.',
            'Swim breaststroke—25 yards.',
            'Swim side stroke—25 yards.',
            'Swim butterfly—10 yards.',
            'Swim approach stroke--25 yards.',
            'Demonstrate breaststroke turn.',
            'Demonstrate speed turn and pull-out for breaststroke.',
            'Demonstrate speed turn for front crawl.',
            'Demonstrate flip turn for front crawl.',
            'Demonstrate pike surface dive.',
            'Demonstrate tuck surface dive.',
            'Tread water for three minutes (one minute with no hands).',
            'Demonstrate throwing rescue.',
            'Demonstrate rolling spinal injury victim to face up.'
        ]
    },
    {
        id: 'temperance',
        title: 'Temperance',
        category: 'Spiritual Growth, Outreach & Heritage',
        level: 2,
        year: 1976,
        institution: 'General Conference',
        summary: 'Study the benefits of living a drug-free and alcohol-free lifestyle.',
        requirements: [
            'Memorize and sign the Temperance Pledge.',
            'Memorize three Bible verses and three Spirit of Prophecy quotations regarding temperance.',
            'Do four of the following: Write speech, essay, jingle, draw poster, make exhibit, make scrapbook, share with others.',
            'Know and explain: Warning on cigarette packet, seven ingredients of tobacco smoke, Emphysema/cirrhosis/addiction, effects on pregnancy.',
            'Read the chapter “Stimulants and Narcotics” in Ministry of Healing.',
            'After studying materials, list three things that contribute to temperance and good health.',
            'Discuss and role play situations involving peer pressure to use tobacco, drugs, or alcohol.'
        ]
    },
    {
        id: 'video',
        title: 'Video',
        category: 'Vocational',
        level: 2,
        year: 2010,
        institution: 'South Pacific Division',
        summary: 'Learn the basics of video production, including filming, editing, and storytelling.',
        requirements: [
            'Be familiar with the type of videos available.',
            'Identify the parts on a video camera and know how to use them.',
            'Know what the viewfinder messages mean.',
            'Identify and change the battery. Know how to charge up the battery.',
            'How else can the camera be powered?',
            'Video a five minute segment, then view with your instructor. Discuss technique.',
            'Demonstrate how to set up and use a tripod.',
            'Demonstrate how to edit video using a VCR (or computer software) by editing segment taken for requirement #6.',
            'Demonstrate your ability to use titles and design your own by hand or computer.',
            'Complete one of the following and show it in a public place. Length of video clip must be 4-7 minutes: Object lesson, Music video clip, Bible story, Nature, Modern life dilemma, Advertisement.'
        ]
    },
    {
        id: 'volleyball',
        title: 'Volleyball',
        category: 'Recreation',
        level: 1,
        year: 1989,
        institution: 'North American Division',
        summary: 'Learn the rules, positions, and skills necessary to play team volleyball.',
        requirements: [
            'Serve over the net.',
            'Demonstrate bumping and setting.',
            'Play a game.'
        ]
    }
];
